import React from "react";
import { Link } from "react-router-dom";

const AwesomeServicesCard = ({ service, awesomeServices }) => {
  return (
    <div
      className={`${awesomeServices.awesomeServicesContainerCard} w-[303px]  mx-auto cursor-pointer  relative z-10 font-roboto`}
    >
      <div className="relative ">
        <img src={service.image} className="w-full" alt="services" />
        <img
          className=" absolute right-5 bottom-[-70px]"
          src={service.icon}
          alt="icons"
        />
      </div>
      <div className="pt-[50px] px-5 pb-10">
        <h3 className=" mb-2 text-xl uppercase  relative font-fira font-bold">
          {service.title}
        </h3>
        <p className=" text-base font-roboto">{service.shortDescription}</p>
        <div className="flex mt-[25px] gap-10 max-sm:gap-0 max-sm:flex-row flex-col max-sm:max-w-[450px] justify-between ">
          <Link to={`/service/${service.slug}`}>
            <button
              style={{ boxShadow: "none" }}
              className="custom_button flex justify-center items-center "
            >
              {" "}
              Details
              <i className="fa-solid fa-arrow-right ml-2"></i>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AwesomeServicesCard;
